const TYPES = {
    JOURNAL_ADD_FIELD: 'journalAddField',
    JOURNAL_ADD_COLUMN: 'journalAddColumn',
    JOURNAL_DOWNLOAD_EXCEL: 'journalDownloadExcel',
    CONFIRMATION: 'confirmation',
    UPLOADING_FILES_TO_MEDIA_PLATFORMS: 'uploadingFilesToMediaPlatforms',
    EDIT_DIRECTION_COPY: 'editDirectionCopy',
    TIPTAP_RESIZE_IMAGE: 'tiptapResizeImage'
}

export default TYPES;